import React from "react";
import MasterForm from "./MasterForm";
import "./Modal.css";
// const Modal = (props) => {
 class Modal extends  React.Component {
        state = {
            currentStep:1
        }

        onUpdate = (val)=>{
            this.setState({
                currentStep:val
            })
            console.log("onUpdate: " +val);
        };
    render(){

    let show = this.props.showModal ? 'show' : '';
    return (
        <div id="weaponsForm" className={"modal fade " + show} tabIndex="-1" role="dialog"  aria-hidden="true">     
        <div className={"modal-dialog step"+this.state.currentStep} role="dialog">
            <div className="modal-header">
            <button type="button" className="close" data-dismis="#weaponsForm" aria-label="Close" onClick={this.props.close}>
                                <span aria-hidden="true">&times;</span>
                    </button>
            </div>
            <div className="modal-content">
                <div className={"modal-body step"+this.state.currentStep}>
                    {/* <p> */}
                    <div className="modalTitle">בדיקת התאמה לייבוא נשק</div>
                       <MasterForm showModal={this.props.showModal} items={this.props.items} onUpdate={this.onUpdate}></MasterForm>
                    {/* </p> */}
                </div>
            </div>
        </div>
        </div>
    )
}
}
    export default Modal;